import _ from "lodash";
import { IModifiersMap } from "../lib";

export function itemReady(modifiers: IModifiersMap) {
  // For only crusts and Toppings and other addons
  let quantityFlag = true;
  let foundModifier = false;
  if (!_.isEmpty(modifiers)) {
    Object.keys(modifiers).forEach((key) => {
      let ModifierQuantityCount = 0;
      if (quantityFlag) {
        modifiers[key].forEach((modifier: any, i: any) => {
          if (modifier.modGroup_min_quantity > 0) {
            if (modifier.selected && modifier.quantity > 0) {
              ModifierQuantityCount += modifier.quantity;
            }
            if (i === modifiers[key].length - 1) {
              if (ModifierQuantityCount < modifier.modGroup_min_quantity) {
                if (!foundModifier) {
                  // toast.warn("Please select max quantity for required option in " + modifier.mod_group_name, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
                  foundModifier = true;
                  quantityFlag = false;
                }
              } else {
                quantityFlag = true;
              }
            }
          }
        });
      }
    });
  } else {
    quantityFlag = true;
  }
  return quantityFlag;
}
